(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/store/assets/javascripts/endpoints/player.js') >= 0) return;  svs.modules.push('/components/tipsen/store/assets/javascripts/endpoints/player.js');
"use strict";

const _excluded = ["wagerId"],
  _excluded2 = ["wagerId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

const playerWagerBasePath = 'player/1/wagers';
const _svs$components$tipse = svs.components.tipsen.store.helpers,
  normalizeWager = _svs$components$tipse.normalizeWager,
  normalizePlayerForecast = _svs$components$tipse.normalizePlayerForecast,
  normalizeWagers = _svs$components$tipse.normalizeWagers;
const products = svs.utils.products;
const FIVE_MINUTES = svs.components.tipsen.store.endpoints.constants.timeAsSeconds.FIVE_MINUTES;
const jupiterFetch = svs.core.jupiterFetch;
const getLogger = svs.core.log.getLogger;
const WagerStatus = svs.components.sport.tipsenShared.WagerStatus;
const playerForecastRequestDelays = svs.components.tipsen.store.endpoints.constants.playerForecastRequestDelays;
const competitionHandler = svs.components.marketplaceCompetition.competitionHandler.competitionHandler;

const fetchPlayerForecast = (qs, productId) => jupiterFetch.fetch("player/1/playerforecast?".concat(qs), {
  method: 'GET'
}).then(res => res.json()).then(res => normalizePlayerForecast(res.getPlayerForecastRequest, productId)).catch(err => err);

const playerForecastManagerCache = {};
const managerLogger = getLogger('tipsen:store:playerForecastManager');
const playerForecastManager = (wagerId, drawId) => {
  const managerKey = "".concat(wagerId, "_").concat(drawId);
  const manager = playerForecastManagerCache[managerKey];
  if (manager) {
    return manager;
  }
  let fetchTimeoutId = 0;
  let isFetched = false;
  let activeArgs = {};
  const newManager = {
    fetch: args => {
      const qs = new URLSearchParams();
      qs.set("drawnum", args.drawNumber);
      qs.set("product", products.resolveITSProductId(args.productId));
      qs.set("serial", args.wagerId);
      qs.set("resultIdx", args.resultIdx);
      Object.assign(activeArgs, args);
      clearTimeout(fetchTimeoutId);
      const currentIsFetched = isFetched;
      isFetched = true;

      if (!currentIsFetched) {
        managerLogger.info("Fetch immediate. wId: ".concat(wagerId, " resultIdx: ").concat(args.resultIdx));
        return fetchPlayerForecast(qs, args.productId);
      }
      return new Promise((resolve, reject) => {
        const delayTime = Math.round(Math.random() * (playerForecastRequestDelays.MAX_DELAY - playerForecastRequestDelays.MIN_DELAY + 1) + playerForecastRequestDelays.MIN_DELAY);
        const _timeoutId = setTimeout(async () => {
          try {
            const playerForecast = await fetchPlayerForecast(qs, args.productId);
            managerLogger.info("Fetched. wId: ".concat(wagerId, ", resultIdx: ").concat(args.resultIdx, ", timeout: ").concat(delayTime, "ms"));
            resolve(playerForecast);
          } catch (err) {
            managerLogger.info("Failed fetch. wId: ".concat(wagerId, ", resultIdx: ").concat(args.resultIdx, ", timeout: ").concat(delayTime, "ms"));
            reject(err);
          }
        }, delayTime);
        managerLogger.info("Fetch delayed. wId: ".concat(wagerId, ", resultIdx: ").concat(args.resultIdx, ", timeout: ").concat(_timeoutId, " prev. timeout: ").concat(fetchTimeoutId));
        fetchTimeoutId = _timeoutId;
      });
    },
    cleanup: _ref => {
      let resultIdx = _ref.resultIdx;
      managerLogger.debug('cleanup run');
      if (resultIdx === activeArgs.resultIdx) {
        managerLogger.debug("cleanup done on resultIdx: ".concat(resultIdx));
        clearTimeout(fetchTimeoutId);
        activeArgs = {};
        isFetched = false;
        fetchTimeoutId = 0;
        delete playerForecastManagerCache[managerKey];
      }
    }
  };
  playerForecastManagerCache[managerKey] = newManager;
  return newManager;
};
const areObjectsEqual = (newObject, currentObject) => Object.keys(newObject).every(key => {
  if (newObject[key] && currentObject[key] && typeof newObject[key] === 'object') {
    return areObjectsEqual(newObject[key], currentObject[key]);
  }
  return Object.hasOwn(currentObject, key) && newObject[key] === currentObject[key];
});
const playerWagerLogger = getLogger('tipsen:store:playerWager');
const getPlayerEndpoints = builder => ({
  getPlayerWagers: builder.query({
    queryFn: async _ref2 => {
      let count = _ref2.count,
        status = _ref2.status,
        productId = _ref2.productId,
        pagingSortKey = _ref2.pagingSortKey;
      const qs = new URLSearchParams();
      qs.set('status', status);
      qs.set('productId', productId);
      if (count) {
        qs.set('count', count);
      }
      if (pagingSortKey) {
        qs.set('pagingSortKey', pagingSortKey);
      }
      const fetchUrl = "".concat(playerWagerBasePath, "?").concat(qs);
      const response = await jupiterFetch.fetch(fetchUrl, {
        method: 'GET'
      }).then(res => res.json());
      let competitions;
      if (response.wagers && response.wagers.length) {
        try {
          const competitionIdsSet = new Set();
          response.wagers.forEach(wager => {
            const competitionId = wager.properties.competitionIds ? wager.properties.competitionIds[0] : undefined;
            if (competitionId) {
              competitionIdsSet.add(competitionId);
            }
          });
          const competitionIds = Array.from(competitionIdsSet);
          if (competitionIds.length) {
            const compHandler = competitionHandler();
            competitions = [].concat(await compHandler.getCompetition(competitionIds));
          }
        } catch (_unused) {
        }
      }
      const wagers = normalizeWagers(response, competitions);
      return {
        data: wagers
      };
    },
    serializeQueryArgs: _ref3 => {
      let endpointName = _ref3.endpointName,
        queryArgs = _ref3.queryArgs;
      const queryObject = {
        productId: queryArgs.productId,
        status: queryArgs.status
      };
      if (queryArgs.contextKey) {
        queryObject.contextKey = queryArgs.contextKey;
      }
      return "".concat(endpointName, "(").concat(JSON.stringify(queryObject), ")");
    },
    merge: function (currentCache, newItems) {
      var _args$;
      const currentCacheWagers = currentCache === null || currentCache === void 0 ? void 0 : currentCache.wagers;
      const newItemsWagers = newItems === null || newItems === void 0 ? void 0 : newItems.wagers;
      let mergedWagers = currentCacheWagers;
      let hasMoreItems = currentCache.moreItems;
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      const pagingSortKey = args === null || args === void 0 || (_args$ = args[0]) === null || _args$ === void 0 || (_args$ = _args$.arg) === null || _args$ === void 0 ? void 0 : _args$.pagingSortKey;
      if (pagingSortKey) {
        mergedWagers = currentCacheWagers.concat(newItemsWagers);
        hasMoreItems = newItems.moreItems;
      } else {
        let replaceCurrentWithNew = false;
        if (newItemsWagers.length === 0) {
          replaceCurrentWithNew = true;
        } else {
          newItemsWagers.forEach((newWager, index) => {
            const currentWager = currentCacheWagers === null || currentCacheWagers === void 0 ? void 0 : currentCacheWagers[index];
            const currentHasAllValues = currentWager && areObjectsEqual(newWager, currentWager);
            if (!currentHasAllValues) {
              replaceCurrentWithNew = true;
            }
          });
        }
        if (replaceCurrentWithNew) {
          mergedWagers = newItemsWagers;
          hasMoreItems = newItems.moreItems;
        }
      }
      Object.assign(currentCache, _objectSpread(_objectSpread({}, newItems), {}, {
        moreItems: hasMoreItems,
        wagers: mergedWagers
      }));
    },
    keepUnusedDataFor: FIVE_MINUTES,
    providesTags: (result, error, _ref4) => {
      let status = _ref4.status;
      return result !== null && result !== void 0 && result.wagers ? [{
        type: 'Wagers',
        id: status
      }] : ['Wagers'];
    }
  }),
  getPlayerWager: builder.query({
    queryFn: async _ref5 => {
      let wagerId = _ref5.wagerId;
      if (!wagerId) {
        throw new Error('WagerId is missing');
      }
      const fetchUrl = "".concat(playerWagerBasePath, "/").concat(wagerId);
      const response = await jupiterFetch.fetch(fetchUrl, {
        method: 'GET'
      }).then(res => res.json());
      let competition;
      if (response && response.wager) {
        var _response$wager$prope, _response$wager$prope2;
        const competitionId = (_response$wager$prope = (_response$wager$prope2 = response.wager.properties.competitionIds) === null || _response$wager$prope2 === void 0 ? void 0 : _response$wager$prope2[0]) !== null && _response$wager$prope !== void 0 ? _response$wager$prope : undefined;
        if (competitionId) {
          const compHandler = competitionHandler();
          competition = await compHandler.getCompetition(competitionId);
        }
      } else {
        return {
          error: response.error
        };
      }
      const wager = normalizeWager(response.wager, competition);
      return {
        data: wager
      };
    },
    providesTags: (result, error, _ref6) => {
      let wagerId = _ref6.wagerId;
      return result ? [{
        type: 'Wager',
        id: wagerId
      }] : ['Wager'];
    },
    transformResponse: res => normalizeWager(res.wager)
  }),
  getPlayerForecast: builder.query({
    queryFn: _ref7 => {
      let wagerId = _ref7.wagerId,
        args = _objectWithoutProperties(_ref7, _excluded);
      const productId = args.productId;
      const drawNumber = args.drawNumber;
      const drawId = "".concat(productId, "_").concat(drawNumber);
      const manager = playerForecastManager(wagerId, drawId);
      return manager.fetch(_objectSpread({
        wagerId
      }, args));
    },
    onCacheEntryAdded: async (_ref8, _ref9) => {
      let cacheEntryRemoved = _ref9.cacheEntryRemoved;
      let wagerId = _ref8.wagerId,
        args = _objectWithoutProperties(_ref8, _excluded2);
      try {
        await cacheEntryRemoved;
      } catch (_unused2) {} finally {
        const productId = args.productId;
        const drawNumber = args.drawNumber;
        const drawId = "".concat(productId, "_").concat(drawNumber);
        playerForecastManager(wagerId, drawId).cleanup(args);
      }
    }
  }),
  invalidatePlayerWagersTag: builder.mutation({
    queryFn: () => ({
      data: null
    }),
    invalidatesTags: [{
      type: 'Wagers',
      id: WagerStatus.Active
    }]
  }),
  invalidatePlayerWagerTag: builder.mutation({
    queryFn: () => ({
      data: null
    }),
    invalidatesTags: (result, error, _ref0) => {
      let wagerId = _ref0.wagerId;
      return [{
        type: 'Wager',
        id: wagerId
      }];
    }
  }),
  examinePlayerWager: builder.mutation({
    queryFn: _ref1 => {
      let productId = _ref1.productId,
        wagerId = _ref1.wagerId,
        drawNumber = _ref1.drawNumber;
      const data = {
        productId: products.resolveITSProductId(productId),
        drawNum: drawNumber,
        examinedSerial: wagerId
      };
      return new Promise((resolve, reject) => {
        svs.components.payment.examineWager.examine(data, error => {
          if (error) {
            const decodedMessage = decodeURIComponent(error.message);
            const errorCode = parseInt(error.code, 10);
            const examineError = new Error("Examine of wager failed: ".concat(decodedMessage), {
              code: errorCode
            });
            reject(examineError);
          }
          resolve({
            data: {}
          });
        });
      });
    },
    async onQueryStarted(_ref10, _ref11) {
      let productId = _ref10.productId,
        wagerId = _ref10.wagerId;
      let dispatch = _ref11.dispatch,
        queryFulfilled = _ref11.queryFulfilled,
        extra = _ref11.extra;
      const args = {
        count: 20,
        status: 'finished',
        productId,
        contextKey: 'lobby'
      };

      const updateWagerList = dispatch(extra.tipsenApi.util.updateQueryData('getPlayerWagers', args, draft => {
        for (let i = 0; i < draft.wagers.length; i++) {
          if (draft.wagers[i].wagerId === wagerId) {
            draft.wagers[i].examined = true;
            break;
          }
        }
      }));
      const updateCurrentWager = dispatch(extra.tipsenApi.util.updateQueryData('getPlayerWager', {
        wagerId
      }, draft => {
        draft.productBet.examined = true;
      }));
      try {
        await queryFulfilled;
      } catch (_ref12) {
        let error = _ref12.error;
        const errorCode = error.code;
        const errorMessage = error.message;
        const isAlreadyExamined = error.message.toLowerCase().includes('already examined');
        if (errorCode === 409 || isAlreadyExamined) {
          playerWagerLogger.info("Examine of wager failed because wager already examined");
        } else {
          playerWagerLogger.warn(errorMessage);
          updateWagerList.undo();
          updateCurrentWager.undo();
        }
      }
    }
  })
});
setGlobal('svs.components.tipsen.store.endpoints.getPlayerEndpoints', getPlayerEndpoints);

 })(window);